import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function valuetext(value, isLogarithmic, label) {
  if (isLogarithmic) {
    // Check if the value is less than or equal to zero
    if (value <= 0) {
      return "$0"; // or any default value you want to display
    }
    return `$${Math.pow(10, value)}`;
  } else {
    if (label === "Age") return `${value} years old`;
    if (label === "Income") {
      return `$${numberWithCommas(value)}`;
    }
  }
}
//
export default function RangeSlider({ onSliderChange, step, label, low, high, min, max, isLogarithmic }) {
  const [value, setValue] = React.useState([low, high]);

  const handleChange = (e, newValue) => {
    setValue(newValue);
    onSliderChange(newValue);
  };

  const logarithmicScale = (value) => Math.log10(value);

  const formattedValues = isLogarithmic ? value.map(logarithmicScale) : value;

  return (
    <Slider
      getAriaLabel={() => label}
      step={step}
      scale={isLogarithmic ? logarithmicScale : (x) => x}
      value={formattedValues}
      onChange={handleChange}
      valueLabelDisplay="auto"
      valueLabelFormat={(v) => valuetext(v, isLogarithmic, label)}
      getAriaValueText={(v) => valuetext(v, isLogarithmic, label)}
      size="medium"
      min={min}
      max={max}
    />
  );
}
